import { render, staticRenderFns } from "./KanyeQuote.vue?vue&type=template&id=05e86660&"
import script from "./KanyeQuote.vue?vue&type=script&lang=js&"
export * from "./KanyeQuote.vue?vue&type=script&lang=js&"
import style0 from "./KanyeQuote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports